module.exports = __webpack_public_path__ + "static/img/join2.5691e5cf.jpg";